import React, { useEffect, useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { DashFilterProps } from '../DashCard';
import './Chart.css';
import { useCentralCalls } from '@src/rest/CentralCalls';

const DashFilterList: React.FC<DashFilterProps> = ({
    item,
    setFilterChange,
    paramName,
    tableName,
    displayColumnName,
    data,
    filterParams // Pass filterParams to retain selection
}) => {

    const { TableSelect } = useCentralCalls();
    const [selectedValue, setSelectedValue] = useState<string | number | null>(null);

    // Set initial value from filterParams if available
    useEffect(() => {
        if (filterParams?.[item.paramName]) {
            setSelectedValue(filterParams[item.paramName]);
        }
    }, [filterParams, item.paramName]);

    const handleChange = (_, dropdownData: any) => {

        setSelectedValue(dropdownData.value); // Update selected value in state
        setFilterChange({ [item.paramName]: dropdownData.value }); // Notify parent
    };
    console.log("IN FILTERLIST>>..");
    console.log(data);
    return (
        <div style={{ margin: '15px' }}>
            <Dropdown
                placeholder="Select an option"
                fluid
                selection
                options={
                    Array.isArray(data)
                        ? data.filter(opt => opt && opt.value != null && opt.text != null)
                        : []
                }
                value={selectedValue ?? ''}
                onChange={handleChange}
                className="force-unhide"
            />
        </div>
    );
};

export default DashFilterList;
